import * as React from "react";
import { useNavigate } from "react-router-dom";
import Typography from "@mui/material/Typography";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import { makeStyles } from "@mui/styles";
import { Colors } from "../constants/styles";
import { formatDate } from "../constants/helper";

const useStyles = makeStyles({
  root: {
    "& .MuiTableCell-head": {
      color: "white",
      backgroundColor: Colors.blue700,
    },
  },
  tableRightBorder: {
    borderWidth: 0,
    borderRightWidth: 1,
    borderColor: "white",
    borderStyle: "solid",
  },
});

export function ShowTableUser({ currentPosts }) {
  let navigate = useNavigate();
  const classes = useStyles();
  return (
    <TableContainer component={Paper} sx={{ width: "100%" }}>
      <Table aria-label="simple table">
        <TableHead className={classes.root}>
          <TableRow>
            <TableCell
              sx={{ fontWeight: "bold" }}
              className={classes.tableRightBorder}
            >
              Username
            </TableCell>
            <TableCell
              sx={{ fontWeight: "bold" }}
              className={classes.tableRightBorder}
            >
              Tipe User
            </TableCell>
            <TableCell sx={{ fontWeight: "bold" }}>Cabang</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {currentPosts.map((user, index) => (
            <TableRow
              key={user.id}
              sx={{
                "&:last-child td, &:last-child th": { border: 0 },
                "&:hover": { bgcolor: Colors.grey300 },
                cursor: "pointer",
              }}
              onClick={() => {
                navigate(`/daftarUser/${user.id}`);
              }}
            >
              <TableCell component="th" scope="row">
                {user.username}
              </TableCell>
              <TableCell>{user.tipeUser}</TableCell>
              <TableCell>{`${user.cabang.id} - ${user.cabang.namaCabang}`}</TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
}

export function ShowTableCustomer({ currentPosts }) {
  let navigate = useNavigate();
  const classes = useStyles();
  return (
    <TableContainer component={Paper} sx={{ width: "100%" }}>
      <Table aria-label="simple table">
        <TableHead className={classes.root}>
          <TableRow>
            <TableCell
              sx={{ fontWeight: "bold" }}
              className={classes.tableRightBorder}
            >
              Kode
            </TableCell>
            <TableCell
              sx={{ fontWeight: "bold" }}
              className={classes.tableRightBorder}
            >
              Nama
            </TableCell>
            <TableCell
              sx={{ fontWeight: "bold" }}
              className={classes.tableRightBorder}
            >
              Nama PIC
            </TableCell>
            <TableCell
              sx={{ fontWeight: "bold" }}
              className={classes.tableRightBorder}
            >
              Alamat
            </TableCell>
            <TableCell
              sx={{ fontWeight: "bold" }}
              className={classes.tableRightBorder}
            >
              Kota
            </TableCell>
            <TableCell sx={{ fontWeight: "bold" }}>Telepon</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {currentPosts.map((user, index) => (
            <TableRow
              key={user.id}
              sx={{
                "&:last-child td, &:last-child th": { border: 0 },
                "&:hover": { bgcolor: Colors.grey300 },
                cursor: "pointer",
              }}
              onClick={() => {
                navigate(`/customer/${user.id}`);
              }}
            >
              <TableCell component="th" scope="row">
                {user.kodeCustomer}
              </TableCell>
              <TableCell>{user.namaCustomer}</TableCell>
              <TableCell>{user.namaPicCustomer}</TableCell>
              <TableCell>{user.alamatCustomer}</TableCell>
              <TableCell>{user.kotaCustomer}</TableCell>
              <TableCell>{user.teleponCustomer}</TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
}

export function ShowTableArsitek({ currentPosts }) {
  let navigate = useNavigate();
  const classes = useStyles();
  return (
    <TableContainer component={Paper} sx={{ width: "100%" }}>
      <Table aria-label="simple table">
        <TableHead className={classes.root}>
          <TableRow>
            <TableCell
              sx={{ fontWeight: "bold" }}
              className={classes.tableRightBorder}
            >
              Kode
            </TableCell>
            <TableCell
              sx={{ fontWeight: "bold" }}
              className={classes.tableRightBorder}
            >
              Nama
            </TableCell>
            <TableCell sx={{ fontWeight: "bold" }}>Telepon</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {currentPosts.map((user, index) => (
            <TableRow
              key={user.id}
              sx={{
                "&:last-child td, &:last-child th": { border: 0 },
                "&:hover": { bgcolor: Colors.grey300 },
                cursor: "pointer",
              }}
              onClick={() => {
                navigate(`/arsitek/${user.id}`);
              }}
            >
              <TableCell component="th" scope="row">
                {user.kodeArsitek}
              </TableCell>
              <TableCell>{user.namaArsitek}</TableCell>
              <TableCell>{user.teleponArsitek}</TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
}

export function ShowTableCabang({ currentPosts }) {
  let navigate = useNavigate();
  const classes = useStyles();
  return (
    <TableContainer component={Paper} sx={{ width: "100%" }}>
      <Table aria-label="simple table">
        <TableHead className={classes.root}>
          <TableRow>
            <TableCell
              sx={{ fontWeight: "bold" }}
              className={classes.tableRightBorder}
            >
              Kode
            </TableCell>
            <TableCell
              sx={{ fontWeight: "bold" }}
              className={classes.tableRightBorder}
            >
              Nama
            </TableCell>
            <TableCell
              sx={{ fontWeight: "bold" }}
              className={classes.tableRightBorder}
            >
              Alamat
            </TableCell>
            <TableCell
              sx={{ fontWeight: "bold" }}
              className={classes.tableRightBorder}
            >
              Telepon
            </TableCell>
            <TableCell sx={{ fontWeight: "bold" }}>PIC</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {currentPosts.map((user, index) => (
            <TableRow
              key={user.id}
              sx={{
                "&:last-child td, &:last-child th": { border: 0 },
                "&:hover": { bgcolor: Colors.grey300 },
                cursor: "pointer",
              }}
              onClick={() => {
                navigate(`/cabang/${user.id}`);
              }}
            >
              <TableCell component="th" scope="row">
                {user.id}
              </TableCell>
              <TableCell>{user.namaCabang}</TableCell>
              <TableCell>{user.alamatCabang}</TableCell>
              <TableCell>{user.teleponCabang}</TableCell>
              <TableCell>{user.picCabang}</TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
}

export function ShowTableProyek({ currentPosts }) {
  let navigate = useNavigate();
  const classes = useStyles();
  return (
    <TableContainer component={Paper} sx={{ width: "100%" }}>
      <Table aria-label="simple table">
        <TableHead className={classes.root}>
          <TableRow>
            <TableCell
              sx={{ fontWeight: "bold" }}
              className={classes.tableRightBorder}
            >
              Kode Proyek
            </TableCell>
            <TableCell
              sx={{ fontWeight: "bold" }}
              className={classes.tableRightBorder}
            >
              Tgl. Proyek
            </TableCell>
            <TableCell
              sx={{ fontWeight: "bold" }}
              className={classes.tableRightBorder}
            >
              Nama
            </TableCell>
            <TableCell
              sx={{ fontWeight: "bold" }}
              className={classes.tableRightBorder}
            >
              Alamat
            </TableCell>
            <TableCell
              sx={{ fontWeight: "bold" }}
              className={classes.tableRightBorder}
            >
              Nama PIC
            </TableCell>
            <TableCell
              sx={{ fontWeight: "bold" }}
              className={classes.tableRightBorder}
            >
              Nama Arsitek
            </TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {currentPosts.map((user, index) => {
            return (
              <TableRow
                key={user.id}
                sx={{
                  "&:last-child td, &:last-child th": { border: 0 },
                  "&:hover": { bgcolor: Colors.grey300 },
                  cursor: "pointer",
                }}
                onClick={() => {
                  navigate(`/daftarProyek/proyek/${user.id}`);
                }}
              >
                <TableCell component="th" scope="row">
                  {user.kodeProyek}
                </TableCell>
                <TableCell>{formatDate(user.tanggalProyek)}</TableCell>
                <TableCell>{user.customer.namaCustomer}</TableCell>
                <TableCell>{user.customer.alamatCustomer}</TableCell>
                <TableCell>{user.customer.namaPicCustomer}</TableCell>
                <TableCell>{user.arsitek.namaArsitek}</TableCell>
              </TableRow>
            );
          })}
        </TableBody>
      </Table>
    </TableContainer>
  );
}

export function ShowTableProyekChild({ currentPosts }) {
  let navigate = useNavigate();
  const classes = useStyles();

  const borderStyle = {
    border: "1px solid rgba(179, 179, 179, 1)",
  };

  return (
    <TableContainer component={Paper} sx={{ width: "100%" }}>
      <Table aria-label="simple table">
        <TableHead className={classes.root}>
          <TableRow>
            <TableCell
              sx={{ fontWeight: "bold" }}
              className={classes.tableRightBorder}
            >
              No. RAB
            </TableCell>
            <TableCell
              sx={{ fontWeight: "bold", textAlign: "center" }}
              className={classes.tableRightBorder}
              colSpan={4}
            >
              Pekerjaan
            </TableCell>
            <TableCell
              sx={{ fontWeight: "bold" }}
              className={classes.tableRightBorder}
            >
              Kirim Gambar
            </TableCell>
            <TableCell
              sx={{ fontWeight: "bold" }}
              className={classes.tableRightBorder}
            >
              Revisi
            </TableCell>
            <TableCell
              sx={{ fontWeight: "bold" }}
              className={classes.tableRightBorder}
            >
              PO
            </TableCell>
            <TableCell
              sx={{ fontWeight: "bold" }}
              className={classes.tableRightBorder}
            >
              Produksi
            </TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {currentPosts.map((user, index) => {
            let data;
            if (user.isRab) {
              data = (
                <>
                  <TableCell
                    component="th"
                    scope="row"
                    style={{
                      fontWeight: "bold",
                      border: "1px solid rgba(179, 179, 179, 1)",
                    }}
                  >
                    {user.noRab} : {formatDate(user.tanggal)}
                  </TableCell>
                  <TableCell style={borderStyle}></TableCell>
                  <TableCell style={borderStyle}></TableCell>
                  <TableCell style={borderStyle}></TableCell>
                  <TableCell style={borderStyle}></TableCell>
                  <TableCell style={borderStyle}></TableCell>
                  <TableCell style={borderStyle}></TableCell>
                  <TableCell style={borderStyle}></TableCell>
                  <TableCell style={borderStyle}></TableCell>
                </>
              );
            } else if (user.isRabPekerjaan) {
              data = (
                <>
                  <TableCell
                    component="th"
                    scope="row"
                    style={{
                      fontWeight: "bold",
                      border: "1px solid rgba(179, 179, 179, 1)",
                    }}
                  ></TableCell>
                  <TableCell
                    style={{
                      fontWeight: "bold",
                      border: "1px solid rgba(179, 179, 179, 1)",
                    }}
                  >
                    {user.rabPekerjaan === true && user.namaRabPekerjaan}
                  </TableCell>
                  <TableCell style={borderStyle}>
                    {user.rabPekerjaanChild === true &&
                      user.namaRabPekerjaanChild}
                  </TableCell>
                  <TableCell style={borderStyle}>
                    {user.jumlah} {user.satuan}
                  </TableCell>
                  <TableCell style={borderStyle}>
                    {user.keteranganRabPekerjaan}
                  </TableCell>
                  <TableCell style={borderStyle}></TableCell>
                  <TableCell style={borderStyle}></TableCell>
                  <TableCell style={borderStyle}></TableCell>
                  <TableCell style={borderStyle}></TableCell>
                </>
              );
            } else if (user.isKirimGambar) {
              data = (
                <>
                  <TableCell
                    component="th"
                    scope="row"
                    style={borderStyle}
                  ></TableCell>
                  <TableCell style={borderStyle}></TableCell>
                  <TableCell style={borderStyle}></TableCell>
                  <TableCell style={borderStyle}></TableCell>
                  <TableCell style={borderStyle}></TableCell>
                  <TableCell style={borderStyle}>
                    ({user.gambarKe}) {formatDate(user.tanggal)} :{" "}
                    {user.keteranganKirimGambar}
                  </TableCell>
                  <TableCell style={borderStyle}></TableCell>
                  <TableCell style={borderStyle}></TableCell>
                  <TableCell style={borderStyle}></TableCell>
                </>
              );
            } else if (user.isRevisi) {
              data = (
                <>
                  <TableCell
                    component="th"
                    scope="row"
                    style={borderStyle}
                  ></TableCell>
                  <TableCell style={borderStyle}></TableCell>
                  <TableCell style={borderStyle}></TableCell>
                  <TableCell style={borderStyle}></TableCell>
                  <TableCell style={borderStyle}></TableCell>
                  <TableCell style={borderStyle}></TableCell>
                  <TableCell style={borderStyle}>
                    {user.noRevisi} : {formatDate(user.tanggal)} :{" "}
                    {user.tipeRevisi} : {user.keteranganRevisi}
                  </TableCell>
                  <TableCell style={borderStyle}></TableCell>
                  <TableCell style={borderStyle}></TableCell>
                </>
              );
            } else if (user.isPreOrder) {
              data = (
                <>
                  <TableCell
                    component="th"
                    scope="row"
                    style={borderStyle}
                  ></TableCell>
                  <TableCell style={borderStyle}></TableCell>
                  <TableCell style={borderStyle}></TableCell>
                  <TableCell style={borderStyle}></TableCell>
                  <TableCell style={borderStyle}></TableCell>
                  <TableCell style={borderStyle}></TableCell>
                  <TableCell style={borderStyle}></TableCell>
                  <TableCell style={borderStyle}>
                    {user.noPreOrder} : {formatDate(user.tanggal)} :{" "}
                    {user.tipePreOrder} : {user.keteranganPreOrder}
                  </TableCell>
                  <TableCell style={borderStyle}></TableCell>
                </>
              );
            } else if (user.isProduksi) {
              data = (
                <>
                  <TableCell
                    component="th"
                    scope="row"
                    style={borderStyle}
                  ></TableCell>
                  <TableCell style={borderStyle}></TableCell>
                  <TableCell style={borderStyle}></TableCell>
                  <TableCell style={borderStyle}></TableCell>
                  <TableCell style={borderStyle}></TableCell>
                  <TableCell style={borderStyle}></TableCell>
                  <TableCell style={borderStyle}></TableCell>
                  <TableCell style={borderStyle}></TableCell>
                  <TableCell style={borderStyle}>
                    {formatDate(user.tanggal)} : {user.tipeProduksi} :{" "}
                    {user.keteranganProduksi}
                  </TableCell>
                </>
              );
            }

            let tempTableColor;
            if (user.isKirimGambar) {
              tempTableColor = Colors.blue300;
            } else if (user.isRevisi) {
              tempTableColor = Colors.red400;
            } else if (user.isPreOrder) {
              tempTableColor = Colors.yellow400;
            } else if (user.isProduksi) {
              tempTableColor = Colors.green400;
            }

            return (
              <TableRow
                key={user.id}
                sx={{
                  "&:last-child td, &:last-child th": { border: 0 },
                  bgcolor: tempTableColor,
                }}
              >
                {data}
              </TableRow>
            );
          })}
        </TableBody>
      </Table>
    </TableContainer>
  );
}

export function ShowTableRab({ currentPosts }) {
  let navigate = useNavigate();
  const classes = useStyles();
  return (
    <TableContainer component={Paper} sx={{ width: "100%" }}>
      <Table aria-label="simple table">
        <TableHead className={classes.root}>
          <TableRow>
            <TableCell
              sx={{ fontWeight: "bold" }}
              className={classes.tableRightBorder}
            >
              No. Rab
            </TableCell>
            <TableCell
              sx={{ fontWeight: "bold" }}
              className={classes.tableRightBorder}
            >
              Tgl. DP RAB
            </TableCell>
            <TableCell
              sx={{ fontWeight: "bold" }}
              className={classes.tableRightBorder}
            >
              Nama Arsitek
            </TableCell>
            <TableCell
              sx={{ fontWeight: "bold" }}
              className={classes.tableRightBorder}
            >
              Kode Proyek
            </TableCell>
            <TableCell
              sx={{ fontWeight: "bold" }}
              className={classes.tableRightBorder}
            >
              Nama Customer
            </TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {currentPosts.map((user, index) => {
            return (
              <TableRow
                key={user.id}
                sx={{
                  "&:last-child td, &:last-child th": { border: 0 },
                  "&:hover": { bgcolor: Colors.grey300 },
                  cursor: "pointer",
                }}
                onClick={() => {
                  navigate(`/daftarRab/rab/${user.id}`);
                }}
              >
                <TableCell component="th" scope="row">
                  {user.noRab}
                </TableCell>
                <TableCell>{formatDate(user.tanggalDpRab)}</TableCell>
                <TableCell>{user.arsitek.namaArsitek}</TableCell>
                <TableCell>{user.proyek.kodeProyek}</TableCell>
                <TableCell>{user.proyek.customer.namaCustomer}</TableCell>
              </TableRow>
            );
          })}
        </TableBody>
      </Table>
    </TableContainer>
  );
}

export function ShowTableRabPekerjaan({ currentPosts, id }) {
  let navigate = useNavigate();
  const classes = useStyles();
  return (
    <TableContainer component={Paper} sx={{ width: "100%" }}>
      <Table aria-label="simple table">
        <TableHead className={classes.root}>
          <TableRow>
            <TableCell
              sx={{ fontWeight: "bold" }}
              className={classes.tableRightBorder}
            >
              Nama Pekerjaan
            </TableCell>
            <TableCell
              sx={{ fontWeight: "bold" }}
              className={classes.tableRightBorder}
            >
              Jumlah
            </TableCell>
            <TableCell
              sx={{ fontWeight: "bold" }}
              className={classes.tableRightBorder}
            >
              Satuan
            </TableCell>
            <TableCell
              sx={{ fontWeight: "bold" }}
              className={classes.tableRightBorder}
            >
              Keterangan
            </TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {currentPosts.map((user, index) => {
            return (
              <TableRow
                key={user.id}
                sx={{
                  "&:last-child td, &:last-child th": { border: 0 },
                  "&:hover": { bgcolor: Colors.grey300 },
                  cursor: "pointer",
                }}
                onClick={() => {
                  navigate(`/daftarRab/rab/${id}/${user.id}`);
                }}
              >
                <TableCell component="th" scope="row">
                  {user.namaRabPekerjaan}
                </TableCell>
                <TableCell>{user.jumlah}</TableCell>
                <TableCell>{user.satuan}</TableCell>
                <TableCell>{user.keteranganRabPekerjaan}</TableCell>
              </TableRow>
            );
          })}
        </TableBody>
      </Table>
    </TableContainer>
  );
}

export function ShowTableRabPekerjaanFormatted({ currentPosts, id }) {
  let navigate = useNavigate();
  const classes = useStyles();
  return (
    <TableContainer component={Paper} sx={{ width: "100%" }}>
      <Table aria-label="simple table">
        <TableHead className={classes.root}>
          <TableRow>
            <TableCell
              sx={{ fontWeight: "bold", textAlign: "center" }}
              className={classes.tableRightBorder}
              colSpan={4}
            >
              PEKERJAAN
            </TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {currentPosts.map((user, index) => {
            let tempFontWeight = "normal";
            if (user.rabPekerjaan) {
              tempFontWeight = "bold";
            }

            let tempTableColor;
            if (user.rabPekerjaanChild) {
              tempTableColor = Colors.grey400;
            }

            return (
              <TableRow
                key={user.id}
                sx={{
                  "&:last-child td, &:last-child th": { border: 0 },
                  bgcolor: tempTableColor,
                  "&:hover": { bgcolor: Colors.grey300 },
                  cursor: "pointer",
                }}
                onClick={() => {
                  if (user.rabPekerjaan) {
                    navigate(`/daftarRab/rab/${id}/${user.id}`);
                  } else if (user.rabPekerjaanChild) {
                    navigate(
                      `/daftarRab/rab/${id}/${user.rabPekerjaanId}/${user.id}`
                    );
                  }
                }}
              >
                <TableCell
                  component="th"
                  scope="row"
                  sx={{ fontWeight: tempFontWeight }}
                >
                  {user.rabPekerjaan === true && user.namaRabPekerjaan}
                </TableCell>
                <TableCell sx={{ fontWeight: tempFontWeight }}>
                  {user.rabPekerjaanChild === true &&
                    user.namaRabPekerjaanChild}
                </TableCell>
                <TableCell sx={{ fontWeight: tempFontWeight }}>
                  {user.jumlah} {user.satuan}
                </TableCell>
                <TableCell sx={{ fontWeight: tempFontWeight }}>
                  {user.keteranganRabPekerjaan}
                </TableCell>
              </TableRow>
            );
          })}
        </TableBody>
      </Table>
    </TableContainer>
  );
}

export function ShowTableRabPekerjaanChild({
  currentPosts,
  id,
  idRabPekerjaan,
}) {
  let navigate = useNavigate();
  const classes = useStyles();
  return (
    <TableContainer component={Paper} sx={{ width: "100%" }}>
      <Table aria-label="simple table">
        <TableHead className={classes.root}>
          <TableRow>
            <TableCell
              sx={{ fontWeight: "bold" }}
              className={classes.tableRightBorder}
            >
              Nama Pekerjaan
            </TableCell>
            <TableCell
              sx={{ fontWeight: "bold" }}
              className={classes.tableRightBorder}
            >
              Jumlah
            </TableCell>
            <TableCell
              sx={{ fontWeight: "bold" }}
              className={classes.tableRightBorder}
            >
              Satuan
            </TableCell>
            <TableCell
              sx={{ fontWeight: "bold" }}
              className={classes.tableRightBorder}
            >
              Keterangan
            </TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {currentPosts.map((user, index) => {
            return (
              <TableRow
                key={user.id}
                sx={{
                  "&:last-child td, &:last-child th": { border: 0 },
                  "&:hover": { bgcolor: Colors.grey300 },
                  cursor: "pointer",
                }}
                onClick={() => {
                  navigate(`/daftarRab/rab/${id}/${idRabPekerjaan}/${user.id}`);
                }}
              >
                <TableCell component="th" scope="row">
                  {user.namaRabPekerjaanChild}
                </TableCell>
                <TableCell>{user.jumlah}</TableCell>
                <TableCell>{user.satuan}</TableCell>
                <TableCell>{user.keteranganRabPekerjaanChild}</TableCell>
              </TableRow>
            );
          })}
        </TableBody>
      </Table>
    </TableContainer>
  );
}

export function ShowTableKirimGambar({ currentPosts }) {
  let navigate = useNavigate();
  const classes = useStyles();
  return (
    <TableContainer component={Paper} sx={{ width: "100%" }}>
      <Table aria-label="simple table">
        <TableHead className={classes.root}>
          <TableRow>
            <TableCell
              sx={{ fontWeight: "bold" }}
              className={classes.tableRightBorder}
            >
              No.
            </TableCell>
            <TableCell
              sx={{ fontWeight: "bold" }}
              className={classes.tableRightBorder}
            >
              Tgl.
            </TableCell>
            <TableCell
              sx={{ fontWeight: "bold" }}
              className={classes.tableRightBorder}
            >
              Customer
            </TableCell>
            <TableCell
              sx={{ fontWeight: "bold" }}
              className={classes.tableRightBorder}
            >
              No. Rab
            </TableCell>
            <TableCell
              sx={{ fontWeight: "bold" }}
              className={classes.tableRightBorder}
            >
              Tgl. DP RAB
            </TableCell>
            <TableCell
              sx={{ fontWeight: "bold" }}
              className={classes.tableRightBorder}
            >
              Gambar Ke-
            </TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {currentPosts.map((user, index) => {
            return (
              <TableRow
                key={user.id}
                sx={{
                  "&:last-child td, &:last-child th": { border: 0 },
                  "&:hover": { bgcolor: Colors.grey300 },
                  cursor: "pointer",
                }}
                onClick={() => {
                  navigate(`/daftarKirimGambar/kirimGambar/${user.id}`);
                }}
              >
                <TableCell component="th" scope="row">
                  {user.noKirimGambar}
                </TableCell>
                <TableCell>{formatDate(user.tanggalKirimGambar)}</TableCell>
                <TableCell>{user.rab.proyek.customer.namaCustomer}</TableCell>
                <TableCell>{user.rab.noRab}</TableCell>
                <TableCell>{formatDate(user.rab.tanggalDpRab)}</TableCell>
                <TableCell>{user.gambarKe}</TableCell>
              </TableRow>
            );
          })}
        </TableBody>
      </Table>
    </TableContainer>
  );
}

export function ShowTableRevisi({ currentPosts }) {
  let navigate = useNavigate();
  const classes = useStyles();
  return (
    <TableContainer component={Paper} sx={{ width: "100%" }}>
      <Table aria-label="simple table">
        <TableHead className={classes.root}>
          <TableRow>
            <TableCell
              sx={{ fontWeight: "bold" }}
              className={classes.tableRightBorder}
            >
              No.
            </TableCell>
            <TableCell
              sx={{ fontWeight: "bold" }}
              className={classes.tableRightBorder}
            >
              Tgl.
            </TableCell>
            <TableCell
              sx={{ fontWeight: "bold" }}
              className={classes.tableRightBorder}
            >
              Customer
            </TableCell>
            <TableCell
              sx={{ fontWeight: "bold" }}
              className={classes.tableRightBorder}
            >
              No. Rab
            </TableCell>
            <TableCell
              sx={{ fontWeight: "bold" }}
              className={classes.tableRightBorder}
            >
              Tgl. DP RAB
            </TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {currentPosts.map((user, index) => {
            return (
              <TableRow
                key={user.id}
                sx={{
                  "&:last-child td, &:last-child th": { border: 0 },
                  "&:hover": { bgcolor: Colors.grey300 },
                  cursor: "pointer",
                }}
                onClick={() => {
                  navigate(`/daftarRevisi/revisi/${user.id}`);
                }}
              >
                <TableCell component="th" scope="row">
                  {user.noRevisi}
                </TableCell>
                <TableCell>{formatDate(user.tanggalRevisi)}</TableCell>
                <TableCell>{user.rab.proyek.customer.namaCustomer}</TableCell>
                <TableCell>{user.rab.noRab}</TableCell>
                <TableCell>{formatDate(user.rab.tanggalDpRab)}</TableCell>
              </TableRow>
            );
          })}
        </TableBody>
      </Table>
    </TableContainer>
  );
}

export function ShowTablePreOrder({ currentPosts }) {
  let navigate = useNavigate();
  const classes = useStyles();
  return (
    <TableContainer component={Paper} sx={{ width: "100%" }}>
      <Table aria-label="simple table">
        <TableHead className={classes.root}>
          <TableRow>
            <TableCell
              sx={{ fontWeight: "bold" }}
              className={classes.tableRightBorder}
            >
              No.
            </TableCell>
            <TableCell
              sx={{ fontWeight: "bold" }}
              className={classes.tableRightBorder}
            >
              Tgl.
            </TableCell>
            <TableCell
              sx={{ fontWeight: "bold" }}
              className={classes.tableRightBorder}
            >
              Customer
            </TableCell>
            <TableCell
              sx={{ fontWeight: "bold" }}
              className={classes.tableRightBorder}
            >
              No. Rab
            </TableCell>
            <TableCell
              sx={{ fontWeight: "bold" }}
              className={classes.tableRightBorder}
            >
              Tgl. DP RAB
            </TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {currentPosts.map((user, index) => {
            return (
              <TableRow
                key={user.id}
                sx={{
                  "&:last-child td, &:last-child th": { border: 0 },
                  "&:hover": { bgcolor: Colors.grey300 },
                  cursor: "pointer",
                }}
                onClick={() => {
                  navigate(`/daftarPreOrder/preOrder/${user.id}`);
                }}
              >
                <TableCell component="th" scope="row">
                  {user.noPreOrder}
                </TableCell>
                <TableCell>{formatDate(user.tanggalPreOrder)}</TableCell>
                <TableCell>{user.rab.proyek.customer.namaCustomer}</TableCell>
                <TableCell>{user.rab.noRab}</TableCell>
                <TableCell>{formatDate(user.rab.tanggalDpRab)}</TableCell>
              </TableRow>
            );
          })}
        </TableBody>
      </Table>
    </TableContainer>
  );
}

export function ShowTableProduksi({ currentPosts }) {
  let navigate = useNavigate();
  const classes = useStyles();
  return (
    <TableContainer component={Paper} sx={{ width: "100%" }}>
      <Table aria-label="simple table">
        <TableHead className={classes.root}>
          <TableRow>
            <TableCell
              sx={{ fontWeight: "bold" }}
              className={classes.tableRightBorder}
            >
              No.
            </TableCell>
            <TableCell
              sx={{ fontWeight: "bold" }}
              className={classes.tableRightBorder}
            >
              Tgl.
            </TableCell>
            <TableCell
              sx={{ fontWeight: "bold" }}
              className={classes.tableRightBorder}
            >
              Customer
            </TableCell>
            <TableCell
              sx={{ fontWeight: "bold" }}
              className={classes.tableRightBorder}
            >
              No. Rab
            </TableCell>
            <TableCell
              sx={{ fontWeight: "bold" }}
              className={classes.tableRightBorder}
            >
              Tgl. DP RAB
            </TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {currentPosts.map((user, index) => {
            return (
              <TableRow
                key={user.id}
                sx={{
                  "&:last-child td, &:last-child th": { border: 0 },
                  "&:hover": { bgcolor: Colors.grey300 },
                  cursor: "pointer",
                }}
                onClick={() => {
                  navigate(`/daftarProduksi/produksi/${user.id}`);
                }}
              >
                <TableCell component="th" scope="row">
                  {user.noProduksi}
                </TableCell>
                <TableCell>{formatDate(user.tanggalProduksi)}</TableCell>
                <TableCell>{user.rab.proyek.customer.namaCustomer}</TableCell>
                <TableCell>{user.rab.noRab}</TableCell>
                <TableCell>{formatDate(user.rab.tanggalDpRab)}</TableCell>
              </TableRow>
            );
          })}
        </TableBody>
      </Table>
    </TableContainer>
  );
}
